import Vue from 'vue';
import Vuex from 'vuex';
import {
  GET_COMPANY_PAYMENT_INFO_GQL,
  GET_PAYMENT_HISTORY,
  GET_PAYMENT_HISTORY_MONTH_WISE,
  GET_PAYMENT_HISTORY_2,
  MAKE_PAYMENT_STRIPE,
  MAKE_PAYMENT_DWOLLA,
  GET_ACHPAYMENT_ID_STRIPE,
  GET_ACHPAYMENT_ID_DWOLLA,
  CREATE_ACH_ACCOUNT_STRIPE,
  CREATE_ACH_ACCOUNT_DWOLLA,
  GET_ACCESS_TOKEN,
  GET_PAYMENT_MODE_GQL,
  ADD_BANK_TRANSACTION_MANUAL_GQL,
  ADD_BANK_TRANSACTION_MANUAL_GQL2,
  UPDATE_BANK_BALANCE_MANUAL_GQL,
  GET_COMPANY_ACH_GQL,
  GET_ACH_TYPE,
  GET_EXTERNAL_CC_TRANSACTION,
} from '@/graphql/payment.gql';

import { defaultClient as apolloClient } from '@/plugins/vue-apollo';


// To connect Plaid
// const dotenv = require('dotenv');


Vue.use(Vuex);

export default {
  namespaced: true,

  state: {
    paymentData: [],
    paymentHistory: [],
    paymentHistoryMonthWise: [],
    paymentHistory2: [],
    paymentSetHistory: null,
    achCustomerAccount: [],
    creteNewAccount: [],
    setAccessToken: [],
    getPaymentModeList: [],
    responseCreditCard: null,
    setBankTransaction: [],
    setBankBalanceManual: null,
    getAchTypeId: null,
    pendingPayment: 0,
    pendingPaymentMonthWise: 0,
  },

  mutations: {
    SET_ALL_COMPANY_PAYMENT(state, payload) {
      state.paymentData = payload;
    },
    SET_PAYMENT_HISTORY(state, payload) {
      state.paymentHistory = payload;
    },
    SET_PAYMENT_HISTORY_MONTH_WISE(state, payload) {
      state.paymentHistoryMonthWise = payload;
    },
    SET_PAYMENT_PAYMENT(state, payload) {
      state.pendingPayment = payload;
    },
    SET_PAYMENT_PAYMENT_MONTH_WISE(state, payload) {
      state.pendingPaymentMonthWise = payload;
    },
    SET_PAYMENT_HISTORY_2(state, payload) {
      state.paymentHistory2 = payload;
    },
    CREATE_PAYMENT_HISTORY(state, payload) {
      state.paymentSetHistory = payload;
    },
    SET_ACH_ACCOUNT(state, payload) {
      state.achCustomerAccount = payload;
    },
    CREATE_NEW_ACH_ACCOUNT(state, payload) {
      state.creteNewAccount = payload;
    },
    SET_ACCESS_TOKEN_ACH(state, payload) {
      state.setAccessToken = payload;
    },
    GET_PAYMENT_MODE_LIST(state, payload) {
      state.getPaymentModeList = payload;
    },
    SET_BANK_TRANSACTION_MANUAL(state, payload) {
      state.setBankTransaction = payload;
    },
    SET_BANK_BALANCE_MANUAL(state, payload) {
      state.setBankBalanceManual = payload;
    },
    GET_ACH_TYPE_ID(state, payload) {
      state.getAchTypeId = payload;
    },
    GET_RESPONSE_GET_CC_CREDIT_CARD(state, payload) {
      state.responseCreditCard = payload;
    },
  },

  actions: {
    async getCompanyPayment({ commit }, payload) {
      if (payload.id === null) {
        commit('SET_ALL_COMPANY_PAYMENT', null);
        return 0;
      }
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient.query({
        query: GET_COMPANY_PAYMENT_INFO_GQL,
        variables: {
          ...payload,
        },
        fetchPolicy: 'network-only',
      })
        .then(({ data }) => {
          commit('SET_ALL_COMPANY_PAYMENT', data.company);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, { root: true });
          console.log(err);
        });
    },

    // get History of Payment
    async bankTransaction({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      const paymentHistoryOne = [];
      let pendingPaymentLocal = 0;
      await apolloClient.query({
        query: GET_PAYMENT_HISTORY,
        variables: {
          ...payload,
        },
        fetchPolicy: 'no-cache',
      })
        .then(({ data }) => {
          const payHistory = data.bankTransaction.sort((a, b) => new Date(a.transactionDate) - new Date(b.transactionDate));
          let balance = 0;

          payHistory.forEach(async (item) => {
            // Calculate Payment & total Expense
            // console.log(item);
            if (item.newCompanyName) {
              balance += item.outGoingAmount;
            } else if ((item.payment < 0 || item.payment > 0) && item.amount === 0) {
              if (item.recordStatus === 3) {
                balance -= item.payment;
                pendingPaymentLocal += item.payment;
              }

              if (item.recordStatus === 1) {
                balance -= item.payment;
              }
            } else {
              balance += item.amount;
            }
            paymentHistoryOne.push({
              ...item,
              balance,
              recordStatus: item.recordStatus,
            });
          });
          commit('SET_PAYMENT_PAYMENT', pendingPaymentLocal);
          commit('SET_PAYMENT_HISTORY', paymentHistoryOne.reverse());
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, { root: true });
          console.log(err);
        });
    },

    async bankTransactionMonthWise({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      const paymentHistoryOne = [];
      let pendingPaymentLocal = 0;
      await apolloClient.query({
        query: GET_PAYMENT_HISTORY_MONTH_WISE,
        variables: {
          ...payload,
        },
        fetchPolicy: 'no-cache',
      })
        .then(({ data }) => {
          const payHistory = data.bankTransactionMonthWise.sort((a, b) => new Date(a.transactionDate) - new Date(b.transactionDate));
          let balance = 0;

          payHistory.forEach(async (item) => {
            // Calculate Payment & total Expense
            // console.log(item);
            if (item.newCompanyName) {
              balance += item.outGoingAmount;
            } else if ((item.payment < 0 || item.payment > 0) && item.amount === 0) {
              if (item.recordStatus === 3) {
                balance -= item.payment;
                pendingPaymentLocal += item.payment;
              }

              if (item.recordStatus === 1) {
                balance -= item.payment;
              }
            } else {
              balance += item.amount;
            }
            paymentHistoryOne.push({
              ...item,
              balance,
              recordStatus: item.recordStatus,
            });
          });
          // console.log('Hello Word', paymentHistoryOne);
          commit('SET_PAYMENT_PAYMENT_MONTH_WISE', pendingPaymentLocal);
          commit('SET_PAYMENT_HISTORY_MONTH_WISE', { value: paymentHistoryOne.reverse(), date: new Date() });
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, { root: true });
          console.log(err);
        });
    },

    // get Hisroty of Payment
    async bankTransaction2({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient.query({
        query: GET_PAYMENT_HISTORY_2,
        variables: {
          ...payload,
        },
        fetchPolicy: 'no-cache',
      })
        .then(({ data }) => {
          commit('SET_PAYMENT_HISTORY_2', data);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, { root: true });
          console.log(err);
        });
    },

    // make Payment
    // get Hisroty of Payment
    async achPaycreadit({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient.mutate({
        mutation: GET_COMPANY_ACH_GQL,
        variables: {
          ...payload,
        },
      })
        .then(async ({ data }) => {
          if ((data.companies[0].achType && data.companies[0].achType.name === 'Stripe') || data.companies[0].achType === null) {
            console.log('Stipe', payload);
            commit('shared/SET_LOADING', true, { root: true });
            await apolloClient.mutate({
              mutation: MAKE_PAYMENT_STRIPE,
              variables: {
                id: payload.id,
                amount: payload.amount,
              },
            })
              .then(({ data }) => {
                data.date = new Date();
                commit('CREATE_PAYMENT_HISTORY', data);
                commit('shared/SET_LOADING', false, { root: true });
              })
              .catch((err) => {
                commit('shared/SET_LOADING', false, { root: true });
                console.log(err);
              });
          } else {
            console.log('Dwolla');
            await apolloClient.mutate({
              mutation: MAKE_PAYMENT_DWOLLA,
              variables: {
                id: payload.id,
                amount: payload.amount,
              },
            })
              .then(({ data }) => {
                data.date = new Date();
                commit('CREATE_PAYMENT_HISTORY', data);
                commit('shared/SET_LOADING', false, { root: true });
              })
              .catch((err) => {
                commit('shared/SET_LOADING', false, { root: true });
                console.log(err);
              });
          }
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, { root: true });
          console.log(err);
        });
    },

    async achCustomerId({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });

      await apolloClient.mutate({
        mutation: GET_COMPANY_ACH_GQL,
        variables: {
          ...payload,
        },
      })
        .then(async ({ data }) => {
          if ((data.companies[0].achType && data.companies[0].achType.name === 'Stripe') || data.companies[0].achType === null) {
            await apolloClient.mutate({
              mutation: GET_ACHPAYMENT_ID_STRIPE,
              variables: {
                ...payload,
              },
            })
              .then(({ data }) => {
                commit('SET_ACH_ACCOUNT', data);
                commit('shared/SET_LOADING', false, { root: true });
              })
              .catch((err) => {
                commit('shared/SET_LOADING', false, { root: true });
                console.log(err);
              });
          } else {
            console.log('Dwolla');
            await apolloClient.query({
              query: GET_ACHPAYMENT_ID_DWOLLA,
              variables: {
                companyId: payload.companyId,
              },
              fetchPolicy: 'no-cache',
            })
              .then(({ data }) => {
                commit('SET_ACH_ACCOUNT', data);
                commit('shared/SET_LOADING', false, { root: true });
              })
              .catch((err) => {
                commit('shared/SET_LOADING', false, { root: true });
                console.log(err);
              });
          }
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, { root: true });
          console.log(err);
        });


      // GET DATA Stripe or Dwolla account;
    },

    async achCreateAccount({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });

      // Get  Payemtn tyep Stirpe or Dwolla ?

      await apolloClient.mutate({
        mutation: GET_COMPANY_ACH_GQL,
        variables: {
          ...payload,
        },
      })
        .then(async ({ data }) => {
          if ((data.companies[0].achType && data.companies[0].achType.name === 'Stripe') || data.companies[0].achType === null) {
            console.log('Stipe');
            await apolloClient.mutate({
              mutation: CREATE_ACH_ACCOUNT_STRIPE,
              variables: {
                ...payload,
              },
            })
              .then(({ data }) => {
                commit('CREATE_NEW_ACH_ACCOUNT', data);
                commit('shared/SET_LOADING', false, { root: true });
              })
              .catch((err) => {
                commit('shared/SET_LOADING', false, { root: true });
                console.log(err);
              });
          } else {
            console.log('Dwolla');
            await apolloClient.mutate({
              mutation: CREATE_ACH_ACCOUNT_DWOLLA,
              variables: {
                companyId: payload.companyId,
                // ...payload,
              },
            })
              .then(({ data }) => {
                commit('CREATE_NEW_ACH_ACCOUNT', data);
                commit('shared/SET_LOADING', false, { root: true });
              })
              .catch((err) => {
                commit('shared/SET_LOADING', false, { root: true });
                console.log(err);
              });
          }


          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, { root: true });
          console.log(err);
        });
    },

    async getPlaidAccessTokenJP({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient.query({
        query: GET_ACCESS_TOKEN,
        variables: {
          ...payload,
        },
        fetchPolicy: 'no-cache',
      })
        .then(({ data }) => {
          commit('SET_ACCESS_TOKEN_ACH', data);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, { root: true });
          console.log(err);
        });
    },
    getPaymentMode({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      apolloClient
        .query({
          query: GET_PAYMENT_MODE_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          commit('GET_PAYMENT_MODE_LIST', data.paymentModes);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    getCCTransactions({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      apolloClient
        .mutate({
          mutation: GET_EXTERNAL_CC_TRANSACTION,
          variables: payload,
        })
        .then(({ data }) => {
          console.log(data);
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('GET_RESPONSE_GET_CC_CREDIT_CARD', data.getCCTransactions);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    addBankTransactionManual({ commit }, payload) {
      let queryVariable = null;
      let payloads = null;
      if (payload.paymentModeOption === false) {
        queryVariable = ADD_BANK_TRANSACTION_MANUAL_GQL;
        payloads = {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          amount: parseFloat(payload.amount),
          companyId: payload.companyId,
          recordStatus: payload.recordStatus,
          details: payload.details,
          modeOfPayment: payload.modeOfPayment,
          transactionDate: payload.transactionDate,
          transactionId: payload.transactionId,
        };
      } else {
        queryVariable = ADD_BANK_TRANSACTION_MANUAL_GQL2;
        payloads = {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          amount: parseFloat(payload.amount),
          companyId: payload.companyId,
          recordStatus: payload.recordStatus,
          details: payload.details,
          modeOfPaymentNew: payload.modeOfPaymentNew,
          transactionDate: payload.transactionDate,
          transactionId: payload.transactionId,
        };
      }

      commit('shared/SET_LOADING', false, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: queryVariable,
          variables: payloads,
        })
        .then(({ data }) => {
          commit('SET_BANK_TRANSACTION_MANUAL', data.createbankTransaction);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    updateCompanyBalance({ commit }, payload) {
      commit('shared/SET_LOADING', false, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: UPDATE_BANK_BALANCE_MANUAL_GQL,
          variables: {
            companyId: payload.companyId,
            ledgerBalance: parseFloat(payload.ledgerBalance),
          },
        })
        .then(({ data }) => {
          commit('SET_BANK_BALANCE_MANUAL', data.updateCompanyBalance);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    getAchType({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      apolloClient
        .query({
          query: GET_ACH_TYPE,
          variables: payload,
        })
        .then(({ data }) => {
          commit('GET_ACH_TYPE_ID', data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
  },

  getters: {
    paymentData: state => state.paymentData,
    paymentHistory: state => state.paymentHistory,
    paymentHistoryMonthWise: state => state.paymentHistoryMonthWise,
    paymentHistory2: state => state.paymentHistory2,
    paymentSetHistory: state => state.paymentSetHistory,
    achCustomerAccount: state => state.achCustomerAccount,
    creteNewAccount: state => state.creteNewAccount,
    setAccessToken: state => state.setAccessToken,
    getPaymentModeList: state => state.getPaymentModeList,
    responseCreditCard: state => state.responseCreditCard,
    setBankTransaction: state => state.setBankTransaction,
    getAchTypeId: state => state.getAchTypeId,
    pendingPayment: state => state.pendingPayment,
    setBankBalanceManual: state => state.setBankBalanceManual,
  },

};
